export interface All_data {

    id: number;

    imgurl: string;

    title: string;

    font?: string;

    persent: string;

    mos?: string;

    saleprice: string;

    price: string;

    review?: string;
}

let all_data: All_data[] = [
    {
        id: 0,

        imgurl: './img/new/img0.jpg',

        title: '마시멜로 데님 크로스백 1종 JNBG7675',

        font: '',

        persent: '24%',

        saleprice: '59,800원',

        price: '78,900원',

        review: '',
    },
    {
        id: 1,

        imgurl: './img/new/img1.jpg',

        title: '썬플라워 반팔티셔츠 올드핑크 MJST7672',

        font: '',

        persent: '28%',

        saleprice: '39,000원',

        price: '27,900원',

        review: 'REVIEW : 1',
    },
    {
        id: 2,

        imgurl: './img/new/img2.jpg',

        title: '써머 라우드 데님 반팔셔츠 빈티지블루 MJSS7663',

        font: '',

        persent: '14%',

        saleprice: '49,000원',

        price: '41,900원',

        review: 'REVIEW : 1',
    },
    {
        id: 3,

        imgurl: './img/new/img3.jpg',

        title: '포티 카라 반팔티셔츠 화이트오트밀 MJST7664',

        font: '',

        persent: '24%',

        saleprice: '34,900원',

        price: '45,900원',

        review: '',
    },
    {
        id: 4,

        imgurl: './img/new/img4.jpg',

        title: '드림플라워 반팔티셔츠 버건디 MJST7667',

        font: '',

        persent: '24%',

        saleprice: '27,900원',

        price: '36,900원',

        review: '',
    },
    {
        id: 5,

        imgurl: './img/new/img5.jpg',

        title: '플랜트 시드 반팔티셔츠 블랙 JIST7661',

        font: '[6/14 예약배송]',

        persent: '29%',

        saleprice: '26,900원',

        price: '38,000원',

        review: '',
    },
    {
        id: 6,

        imgurl: './img/new/img6.jpg',

        title: '플랜트 시드 반팔티셔츠 오트밀 JIST7661',

        font: '[6/14 예약배송]',

        persent: '29%',

        saleprice: '26,900원',

        price: '38,000원',

        review: '',
    },
    {
        id: 7,

        imgurl: './img/new/img7.jpg',

        title: '문 어라운드 반팔티셔츠 블랙 MJST7657',

        font: '',

        persent: '26%',

        saleprice: '25,900원',

        price: '35,000원',

        review: 'REVIEW : 3',
    },
    {
        id: 8,

        imgurl: './img/new/img8.jpg',

        title: '문 어라운드 반팔티셔츠 라이트베이지 MJST7657',

        font: '',

        persent: '26%',

        saleprice: '25,900원',

        price: '35,000원',

        review: 'REVIEW : 1',
    },
    {
        id: 9,

        imgurl: './img/new/img9.jpg',

        title: '더틴 워싱 데님펜츠 블루 MJLP7674',

        font: '',

        persent: '17%',

        saleprice: '45,900원',

        price: '55,000원',

        review: '',
    },
    {
        id: 10,

        imgurl: './img/new/img10.jpg',

        title: '[패키지] 져니홈+어뉴+투두 반팔티셔츠 2PACK (MJST7662+MJSU7665+MJST7660)',

        font: '[6/8 예약배송]',

        persent: '44%',

        saleprice: '38,900원',

        price: '69,000원',

        review: 'REVIEW : 1',
    },
    {
        id: 11,

        imgurl: './img/new/img11.jpg',

        title: '어뉴 반팔티셔츠 화이트 MJST7662',

        font: '[6/8 예약배송]',

        persent: '26%',

        saleprice: '25,900원',

        price: '34,900원',

        review: '',
    },
    {
        id: 12,

        imgurl: './img/best10/img1.jpg',

        title: '[패키지] 22s/s 반팔티 2PACK',

        mos: '2',

        font: '',

        persent: '33%',

        saleprice: '38,900원',

        price: '59,600원',

        review: 'REVIEW : 24',
    },
    {
        id: 13,

        imgurl: './img/best10/img2.jpg',

        title: '[패키지] 레코드+픽시+라운드 반팔티셔츠 2PACK (MJST7584+MJST7583+MJST7595)',

        mos: '3',

        font: '',

        persent: '43%',

        saleprice: '38,800원',

        price: '70,400원',

        review: 'REVIEW : 5',
    },
    {
        id: 14,

        imgurl: './img/best10/img3.jpg',

        title: '[패키지] 스티비베어+스티비 컬리지+올디 반팔티셔츠 2PACK (JJST7596+SHST7597+JIST7587)',

        mos: '4',

        font: '',

        persent: '48%',

        saleprice: '38,800원',

        price: '76,000원',

        review: 'REVIEW : 3',
    },
    {
        id: 15,

        imgurl: './img/best10/img4.jpg',

        title: '라이닝 니트 베스트 라이트베이지 JNKN7669',

        mos: '5',

        font: '',

        persent: '23%',

        saleprice: '39,800원',

        price: '52,000원',

        review: 'REVIEW : 1',
    },
    {
        id: 16,

        imgurl: './img/best10/img5.jpg',

        title: '스카시 오픈카라 꽈배기 니트 아이보리 JJKN7668',

        mos: '6',

        font: '',

        persent: '23%',

        saleprice: '45,900원',

        price: '59,800원',

        review: 'REVIEW : 1',
    },
    {
        id: 17,

        imgurl: './img/best10/img6.jpg',

        title: '[패키지] 픽시 반팔티셔츠 2PACK MJST7583',

        mos: '7',

        font: '',

        persent: '45%',

        saleprice: '39,800원',

        price: '73,000원',

        review: 'REVIEW : 8',
    },
    {
        id: 18,

        imgurl: './img/best10/img7.jpg',

        title: '라이닝 니트 베스트 라벤더 JNKN7669',

        mos: '8',

        font: '',

        persent: '23%',

        saleprice: '39,800원',

        price: '52,000원',

        review: 'REVIEW : 8',
    },
    {
        id: 19,

        imgurl: './img/best10/img8.jpg',

        title: '[패키지] 투두 반팔티셔츠 2PACK MJST7660',

        mos: '9',

        font: '',

        persent: '41%',

        saleprice: '39,800원',

        price: '68,000원',

        review: 'REVIEW : 1',
    },
    {
        id: 20,

        imgurl: './img/best10/img9.jpg',

        title: '[패키지] 헤비 더블체인 반팔티셔츠 2PACK KHST7398',

        mos: '10',

        font: '[6/15 예약배송]',

        persent: '41%',

        saleprice: '39,800원',

        price: '65,800원',

        review: 'REVIEW : 93',
    },
    {
        id: 21,

        imgurl: './img/top/img3.jpg',

        title: '트랙패치 반팔티셔츠 크림 JIST7601',

        mos: '4',

        font: '',

        persent: '30%',

        saleprice: '26,500원',

        price: '38,000원',

        review: 'REVIEW : 1',
    },
    {
        id: 22,

        imgurl: './img/top/img9.jpg',

        title: '포티 카라 반팔티셔츠 아이보리 MJST7664',

        mos: '10',

        font: '',

        persent: '24%',

        saleprice: '34,900원',

        price: '45,900원',

        review: '',
    },
    {
        id: 23,

        imgurl: './img/pants/img0.jpg',

        title: '[패키지] 로우키 밴딩 쿨 벌룬 팬츠 2PACK CJLP7492',

        mos: '1',

        font: '',

        persent: '51%',

        saleprice: '39,800원',

        price: '82,000원',

        review: 'REVIEW : 15',
    },
    {
        id: 24,

        imgurl: './img/pants/img1.jpg',

        title: '하이픈 데님팬츠 블루 CJLP7523',

        mos: '2',

        font: '',

        persent: '51%',

        saleprice: '38,900원',

        price: '55,800원',

        review: 'REVIEW : 8',
    },
    {
        id: 25,

        imgurl: './img/pants/img2.jpg',

        title: '로너 와이드 코튼팬츠 카키 JJLP7639',

        mos: '3',

        font: '',

        persent: '23%',

        saleprice: '36,900원',

        price: '47,900원',

        review: '',
    },
    {
        id: 26,

        imgurl: './img/pants/img3.jpg',

        title: '라운드 하드택 하프팬츠 차콜 JISP7656',

        mos: '4',

        font: '',

        persent: '23%',

        saleprice: '32,900원',

        price: '42,800원',

        review: '',
    },
    {
        id: 27,

        imgurl: './img/pants/img4.jpg',

        title: '플레인(여름용) 코튼 밴딩 팬츠 모카 CJLP7509',

        mos: '5',

        font: '',

        persent: '30%',

        saleprice: '31,900원',

        price: '45,800원',

        review: 'REVIEW : 1',
    },
    {
        id: 28,

        imgurl: './img/pants/img5.jpg',

        title: '플레인(여름용) 코튼 밴딩 팬츠 아이보리 CJLP7509',

        mos: '6',

        font: '',

        persent: '30%',

        saleprice: '31,900원',

        price: '45,800원',

        review: 'REVIEW : 3',
    },
    {
        id: 29,

        imgurl: './img/pants/img6.jpg',

        title: '크러쉬 워싱 숏팬츠 베이지 MJSP7673',

        mos: '7',

        font: '',

        persent: '23%',

        saleprice: '36,900원',

        price: '48,000원',

        review: '',
    },
    {
        id: 30,

        imgurl: './img/pants/img7.jpg',

        title: '크러쉬 워싱 숏팬츠 올드핑크 MJSP7673',

        mos: '8',

        font: '',

        persent: '23%',

        saleprice: '36,900원',

        price: '48,000원',

        review: '',
    },
    {
        id: 31,

        imgurl: './img/pants/img8.jpg',

        title: '크러쉬 워싱 숏팬츠 카키 MJSP7673',

        mos: '9',

        font: '',

        persent: '23%',

        saleprice: '36,900원',

        price: '48,000원',

        review: 'REVIEW : 1',
    },
    {
        id: 32,

        imgurl: './img/pants/img9.jpg',

        title: '[패키지] 라운드 하드택 하프팬츠 2PACK JISP7656',

        mos: '10',

        font: '[6/20 예약배송]',

        persent: '42%',

        saleprice: '49,800원',

        price: '85,600원',

        review: 'REVIEW : 2',
    },
    {
        id: 33,

        imgurl: './img/special/img0.jpg',

        title: '멀티웨이 백팩 CJBG7405',

        mos: '30%',

        persent: '30%',

        saleprice: '55,800',

        price: '80,000'
    },
    {
        id: 34,

        imgurl: './img/special/img1.jpg',

        title: '올디네리 반팔티셔츠 옐로우 JIST7607',

        mos: '44%',

        persent: '44%',

        saleprice: '18,900',

        price: '33,900'
    },
    {
        id: 35,

        imgurl: './img/special/img2.jpg',

        title: '[패키지] 베리 카라 반팔티셔츠 2PACK KMST7598',

        mos: '52%',

        persent: '52%',

        saleprice: '35,700',

        price: '73,800'
    },
    {
        id: 36,

        imgurl: './img/special/img3.jpg',

        title: '미드썸머 스트라이프 반팔티셔츠 그레이 JIST7508',

        mos: '45%',

        persent: '45%',

        saleprice: '19,800',

        price: '35,900'
    },
    {
        id: 37,

        imgurl: './img/special/img4.jpg',

        title: '베리 카라 반팔티셔츠 네이비 KMST7598',

        mos: '32%',

        persent: '32%',

        saleprice: '25,000',

        price: '36,900'
    },
    {
        id: 38,

        imgurl: './img/special/img5.jpg',

        title: '팜트리 반팔티셔츠 네이비 JIST7503',

        mos: '37%',

        persent: '37%',

        saleprice: '16,900',

        price: '26,900'
    },
    {
        id: 39,

        imgurl: './img/special/img6.jpg',

        title: '팜트리 반팔티셔츠 네이비 JIST7503',

        mos: '37%',

        persent: '37%',

        saleprice: '16,900',

        price: '26,900'
    },
    {
        id: 40,

        imgurl: './img/special/img7.jpg',

        title: '럼블 코듀로이 팬츠 크림 CJLP7349',

        mos: '60%',

        persent: '60%',

        saleprice: '14,300',

        price: '35,900'
    },
    {
        id: 41,

        imgurl: './img/special/img8.jpg',

        title: '홀로그램 카라비너 키링 블랙 CJAC7337',

        mos: '59%',

        persent: '59%',

        saleprice: '4,900',

        price: '12,000'
    },
]

export default all_data;